// The recurring broken hairline between sections — a gap in a rule.
export default function Seam() {
  return (
    <div className="wrap">
      <div className="seam" aria-hidden="true">
        <span></span>
        <span></span>
      </div>
    </div>
  );
}
